import { render, staticRenderFns } from "./newEnrollment.vue?vue&type=template&id=2a8f6189&"
import script from "./newEnrollment.vue?vue&type=script&lang=js&"
export * from "./newEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports